// MaterialReservationApp.js — Stitch design
import React from "react";
import { Box } from "@mui/material";
import { useMaterialReservation } from './MaterialReservationContext';
import { MaterialenOverzicht } from './MaterialenOverzicht';
import { DraaidagenOverzicht } from './DraaidagenOverzicht';

export const AppContent = React.memo(function AppContent() {
    const { selectedDraaidag } = useMaterialReservation();

    return (
        <Box sx={{ width: '100%', px: { xs: 2, sm: 3, md: 5 }, pt: { xs: 3, md: 5 }, pb: 10 }}>
            {selectedDraaidag ? <MaterialenOverzicht /> : <DraaidagenOverzicht />}
        </Box>
    );
});
